import { render, staticRenderFns } from "./LoadFailed.vue?vue&type=template&id=5cfa6042&scoped=true&"
import script from "@/views/Errors/LoadFailed.ts?vue&type=script&lang=ts&"
export * from "@/views/Errors/LoadFailed.ts?vue&type=script&lang=ts&"
import style0 from "@/views/Errors/load-failed.scss?vue&type=style&index=0&id=5cfa6042&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfa6042",
  null
  
)

export default component.exports